export default "__VITE_ASSET__CEE5lv87__"